<div class="table mt-0100"
     *ngIf="entity">

  <!--Menu Button Template-->
  <mat-menu class="popover__menu ignore-click"
            #phoneMenu="matMenu">
    <ng-template matMenuContent
                 let-phone="phone">
      <ng-container *ngIf="isBad(phone); then badButtons else goodButtons">
      </ng-container>

      <ng-template #badButtons>
        <button mat-menu-item
                (click)="onSetStatus(phone, 'user_added')">
          <span class="link link--green link--noline">Restore</span>
        </button>
      </ng-template>

      <ng-template #goodButtons>

        <button mat-menu-item
                (click)="onEdit(phone)">Edit
        </button>
        <button mat-menu-item
                *ngIf="!isVerified(phone)"
                (click)="onSetStatus(phone, 'verified')">
          <span class="link link--green link--noline">Mark as confirmed</span>
        </button>
        <button mat-menu-item
                *ngIf="isVerified(phone)"
                (click)="onSetStatus(phone, 'user_added')">
          Unmark as confirmed
        </button>

        <button mat-menu-item
                *ngIf="!phone.subscribed"
                (click)="onSetSubscribed(phone, true)">
          <span class="link link--green link--noline">Mark as subscribed</span>
        </button>

        <button mat-menu-item
                *ngIf="phone.subscribed"
                (click)="onSetSubscribed(phone, false)">
          Unmark as subscribed
        </button>

        <mat-divider></mat-divider>
        <button mat-menu-item
                *ngIf="!isDoNotContact(phone)"
                (click)="onSetStatus(phone, 'do_not_contact')">
          <span class="link link--noline link--red">Mark as do not contact</span>
        </button>
        <button mat-menu-item
                *ngIf="isDoNotContact(phone)"
                (click)="onSetStatus(phone, 'user_added')">
          Unmark as do not contact
        </button>

        <button mat-menu-item
                (click)="onSetStatus(phone, 'bad')">
          <span class="link link--noline link--red"
                data-test-id="markAsBad">Mark as bad</span>
        </button>
      </ng-template>
    </ng-template>
  </mat-menu>


  <div class="tr tr--noGutter tile__heading pt-0 pb-0">
    Phones
    <ng-container *ngIf="showTaskDoneMark">
      <span class="color--gray ml-0050">
        &bull;
        <span class="color--green">
          <span class="d-none d-inline--md uppercase ml-0025">Done</span>
          <i class="far fa-check ml-0025"></i>
        </span>
      </span>
    </ng-container>
    <button mat-button
            disableRipple
            class="addNew ml-auto mat-button--no-focus-overlay"
            *ngIf="!readonly"
            (click)="onAddNew()">
      <i class="far fa-plus addNew__icon"></i>
      Add
    </button>
  </div>

  <div class="tr trContact entity-tr--contact"
       *ngFor="let phone of sortByBest(entity.phoneNumbers, showBad)"
       [ngClass]="{'tr--red': isBad(phone)}">
    <div class="tc trContact__title flexAlign-center">
      <a *ngIf="!isDoNotContact(phone)"
         class="link link--black link--noline"
         [attr.href]="'tel:' + phone.number"
         title="{{phone.number | phone}} {{phone.ext ? 'Ext. ' + phone.ext : ''}}">{{phone.number | phone}}
        {{phone.ext ? 'Ext. ' + phone.ext : ''}}</a>
      <span *ngIf="isDoNotContact(phone)"
            class="txt-fw-500 color--gray--007"
            title="{{phone.number | phone}} {{phone.ext ? 'Ext. ' + phone.ext : ''}}">{{phone.number | phone}}
        {{phone.ext ? 'Ext. ' + phone.ext : ''}}</span>
      <i class="fas fa-ban color--red pair__verified ml-0050"
         *ngIf="isDoNotContact(phone)"
         matTooltip="Marked as Do Not Contact"
         matTooltipPosition="above"></i>
      <i class="far fa-times-circle pair__red ml-0050"
         *ngIf="isBad(phone)"
         matTooltip="Marked as Bad"
         matTooltipPosition="above"></i>
      <i class="far fa-check pair__verified ml-0050"
         *ngIf="isVerified(phone)"
         matTooltip="Confirmed"
         matTooltipPosition="above"></i>
      <i class="far fa-bell-on pair__verified ml-0050"
         *ngIf="phone.subscribed"
         matTooltip="Subscribed"
         matTooltipPosition="above"></i>
      <a class="dupe-info-btn ml-0050"
         (click)="onFlagSharedInfoClick(phone)"
         matTooltip="This phone number is shared by more than one {{entity.entityType.nameSingular}}. Click to view them all."
         *ngIf="isSharedPhone(phone.number, phone.ext)">
        <i class="far fa-circle-exclamation"></i>
      </a>
    </div>

    <div class="tc tc--xs trContact__type">{{phone.numberType | propercase}}</div>

    <div class="tc tc--xs trContact__type">{{phone.source | source}}</div>

    <div class="tc tc--light tc--xs trContact__meta"
         title="{{phone.updatedAt|date:'medium'}}">
      Edited {{phone.updatedAt | relativeDate}}
    </div>

    <div class="tr__drawer tr__drawer--sm drawer"
         *ngIf="!readonly">
      <button class="drawer__btn"
              type="button"
              [matMenuTriggerFor]="phoneMenu"
              [matMenuTriggerData]="{phone: phone}">
        <i class="far fa-fw fa-ellipsis-h fa--gray"></i>
      </button>
    </div>
  </div>

  <div class="tr tr--noGutter tr--sm tr--gray"
       *ngIf="getBadCount(entity.phoneNumbers) > 0">
    <div class="addNew addNew--red ml-auto mr-0025"
         (click)="showBad = !showBad"
         data-test-id="togglePhoneShowBad">
      <ng-container *ngIf="!showBad">
        <span class="addNew__text">
          View Bad (<strong data-test-id="phoneBadCount">{{getBadCount(entity.phoneNumbers)}}</strong>)
        </span>
        <i class="far fa-chevron-down ml-0050 addNew__text--gray"></i>
      </ng-container>
      <ng-container *ngIf="showBad">
        <span class="addNew__text">
          Hide Bad (<strong data-test-id="phoneBadCount">{{getBadCount(entity.phoneNumbers)}}</strong>)
        </span>
        <i class="far fa-chevron-up ml-0050 addNew__text--gray"></i>
      </ng-container>
    </div>
  </div>
</div>
